import deepmerge from "deepmerge";
import isPlainObject from "is-plain-object";

export default function mergeDocumentData(doc, data) {
	return deepmerge(doc, data, {
		isMergeableObject: (value) => {
			// igonore firestore refs
			return isPlainObject(value) && !value?.firestore;
		},
	});
}
